import { toValue, useQuery } from '#imports'

export interface VendorResponse {
    name: string
    slug: string
}

export const useVendors = (options: { enabled: boolean } = { enabled: true }) => {
    const query = useQuery<VendorResponse[]>('/gateway/game-configuration/public/vendors', {
        key: 'game:vendors',
        immediate: toValue(options.enabled),
        service: 'gameConfiguration',
    })

    return query
}
